import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { catchError, map, of, switchMap } from "rxjs";
import { RequirementsOverrideNSwagMigrationService } from "../../api/migration/requirements-override-nswag-migration.service";
import { RequirementOverrideDetail } from "../../models/requirement-override-detail.model";
import { loadRequirementOverrideDetails, loadRequirementOverrideDetailsFailure, loadRequirementOverrideDetailsSuccessfully, setRequirementOverrideIsLoadingFlag } from "../actions/requirement-override.actions";
import { ComplianceState } from "../state/compliance.state";

@Injectable()
export class RequirementOverrideEffects {
    loadRequirementOverrideDetails$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(loadRequirementOverrideDetails),
            switchMap((action) => {
                this._store.dispatch(setRequirementOverrideIsLoadingFlag({ isLoading: true }));
                return this._requirementsOverrideService.getRequirementOverrideDetail(action.documentTypeId, action.entityType, action.entityId).pipe(
                    map((result: RequirementOverrideDetail) => {
                        this._store.dispatch(setRequirementOverrideIsLoadingFlag({ isLoading: false }));
                        return loadRequirementOverrideDetailsSuccessfully({ details: result });
                    }),
                    catchError((result: unknown) => of(loadRequirementOverrideDetailsFailure({ error: result })))
                );
            })
        );
    });

    constructor(
        private readonly _actions$: Actions,
        private readonly _requirementsOverrideService: RequirementsOverrideNSwagMigrationService,
        private readonly _store: Store<ComplianceState>
    ) {}
}
